import { http } from '../../core/services/http';
import { InferenceAudit } from '../interfaces/interfaces';

const saveInferenceAudit = (inferenceAudit: InferenceAudit, auditId: number) =>
  http
    .put(`inferenceAudit/${auditId}`, inferenceAudit)
    .catch(({ response: { status, statusText, data } }) => Promise.reject({ status, statusText, ...data }));

export default saveInferenceAudit;
